import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  Music, 
  Users, 
  Mail, 
  FileText,
  Send,
  Calendar,
  LogOut, 
  Menu, 
  X 
} from 'lucide-react';
import './Layout.css';

const Layout = ({ children, onLogout }) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const menuItems = [
    { path: '/', icon: Home, label: 'Dashboard' },
    { path: '/samples', icon: Music, label: 'Samples' },
    { path: '/subscribers', icon: Users, label: 'Subscribers' },
    { path: '/tracking', icon: Mail, label: 'Email Tracking' },
    { path: '/custom-emails', icon: Send, label: 'Custom Emails' },
    { path: '/template', icon: FileText, label: 'Email Template' },
    { path: '/advent-calendar', icon: Calendar, label: 'Advent Calendar' },
  ];

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>Samplesphere Admin</h2>
          <button className="close-btn" onClick={() => setSidebarOpen(false)}>
            <X size={24} />
          </button>
        </div>
        
        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${isActive ? 'active' : ''}`}
                onClick={() => setSidebarOpen(false)}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>
        
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={onLogout}>
            <LogOut size={20} />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div className="main-content">
        <header className="topbar">
          <button className="menu-btn" onClick={() => setSidebarOpen(true)}>
            <Menu size={24} />
          </button>
          <h1>Admin Dashboard</h1>
        </header>
        
        <main className="content">
          {children}
        </main>

        <footer className="footer">
          <p>2025 © Soave Music Group</p>
        </footer>
      </div>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div className="overlay" onClick={() => setSidebarOpen(false)} />
      )}
    </div>
  );
};

export default Layout;

